export default class CommandArgGroupInfo
{
	remoteClass = "gongqi.erp.gotmodel.form.remote.CommandArgGroupInfo";
	formId;
	groupAlias;
	mainSourceTableName;
	currentRecord;
	currentDataField;
	selectedRecords;
	allRecords;
	currentQuery;
	formQuery;
	
	hasColumnAsSysSelectRecords;
}



// WEBPACK FOOTER //
// ./src/forms/sys/remote/CommandArgGroupInfo.js